import React from 'react';
import { Image } from "@project-stories/elements/Image/Image";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export default function Grid({settings, section, columns}) {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint || "1024px");

  return (
    <div className="flex flex-col lg:flex-row gap-8 items-center" >
      <div className={`flex flex-col gap-8 lg:gap-11 w-full lg:w-96 text-${section.text_alignment_mobile} lg:text-${section.text_alignment}`}>
        <div>
          {section.tagline && <div className="b_a1 pb-2">{section.tagline}</div>}
          <div className={`${isMobile ? section.title_font_type_mobile : section.title_font_type}`}>
            {section.title}
          </div>
        </div>
        <div className={`${isMobile ? section.subtitle_style_mobile : section.subtitle_style}`}>
          {section.subtitle}
        </div>
      </div>
      <div className={`flex-1 grid grid-cols-1 lg:grid-cols-2 md:col-span-2
        gap-x-[${isMobile ? section.gap_mobile : section.gap}px]
        gap-y-[${isMobile ? section.gap_y_mobile : section.gap_y}px]
        `}>
        {columns.map((column, index) => (
          column.settings.layout_variant === "layout-variant-b" ? (
            <div key={index} className="px-8 py-12 bg-[rgba(251,248,244,0.1)] backdrop-blur-md border border-white/20 shadow-lg rounded">
              <div className="flex items-center justify-between gap-12">
                <div className="flex flex-col gap-1">
                  {column.settings.title && <span className="d1">{column.settings.title}</span>}

                  {column.settings.subtitle && (
                    <div className={`${isMobile ? 'b_regular_light' : 'b_large_light'}`}>
                      {column.settings.subtitle}
                    </div>
                  )}

                  {column.settings.content && (
                    <div className="b_tiny_light">
                      {column.settings.content}
                    </div>
                  )}
                </div>
                <div className="flex justify-center items-center w-[92px] h-[92px]">
                  <Image classes="w-[92px] h-[92px]" imageUrl={column.settings.image_icon} alt={column.settings.title} height="92" width="92" />
                </div>
              </div>
            </div>
          ) : (
            <div key={index} className="px-8 py-12 border border-[#C6C9C3] rounded">
              <div className="flex items-center justify-between">
                <span className="d1">{column.settings.title}</span>
                <div className="flex justify-center items-center gap-2 w-24 h-24 rounded-[80px]">
                  <Image classes="w-24  h-24" imageUrl={column.settings.image_icon} alt={column.settings.title} height="60" width="60" />
                </div>
              </div>
              <div className={`${isMobile ? 'b_regular_light' : 'b_large_light'} pt-1`}>
                {column.settings.subtitle}
              </div>
              <div className="b_tiny_light pt-6">
                {column.settings.content}
              </div>
            </div>
          )
        ))}
      </div>
    </div>
  );
}